
import declare from "dojo/_base/declare";
import enums from "csi/enums";
import Widget from "csi/form/Widget";
import reflection from "csi/reflection";

const PRODUCT_TYPES = "ProductTypes";
const PRODUCT_TYPE = "ProductType";

const ProjectLineItemController = declare(Widget, {

	/**
	 * @override
	 * Filter the store for field to display Style / Material / Food dropdown 
	 * values depending upon Project Configuration
	 */
	getFieldStore: function (field, value) {
		const nodeSet = reflection.getNodeSetting(this.cacheView.get(this.viewParent.urlRoot), PRODUCT_TYPES);
		if (field.m_name === PRODUCT_TYPE) {
			return enums.getStore(field.m_name, value,  (value) => nodeSet?.includes(value));
		} else {
			return this.inherited(arguments);
		}
	},
});

export = ProjectLineItemController;